// setRegisterUsername.js
'use strict';
import _ from 'lodash';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import fetchIsUsernameAvailable from './fetchIsUsernameAvailable.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { RE_USERNAME } from '../RemoteConfigKeys.js';
const selectPath = ['register'];
const localValidator = new RegExp(/^[a-z0-9_.]{3,20}$/);
let debouncedFetchIsUsernameAvailable = undefined;

/**
 * Set register username
 * @kind action
 * @param {string} {username} - username.
 * @return {Promise} Action promise.
 */
const setRegisterUsername =
  ({ username }) =>
  async (dispatch, getState) => {
    const lowerUsername = username.slice(0, 20).toLowerCase();
    const reUsername = getRemoteConfigData(getState(), RE_USERNAME);
    const validator = reUsername ? new RegExp(reUsername) : localValidator;
    const isUsernameFormatCorrect = validator.test(lowerUsername);
    if (!debouncedFetchIsUsernameAvailable) {
      debouncedFetchIsUsernameAvailable = _.debounce(
        ({ username }) => dispatch(fetchIsUsernameAvailable({ username })),
        500
      );
    }
    if (isUsernameFormatCorrect) {
      debouncedFetchIsUsernameAvailable({ username: lowerUsername });
    }
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        data: {
          username: lowerUsername,
          isUsernameFormatCorrect,
        },
        selectPath,
      },
    });
  };

export default setRegisterUsername;
